<template>
  <p class="distances-note">
    <translate tag="strong"> Please note: </translate>
    <translate>
      All distances on this page are calculated 'as the crow flies' - please
      check actual distance depending on your mode of travel using the Get
      directions button above.
    </translate>
  </p>
</template>
<style scoped>
.distances-note {
  font-size: var(--small);
}
</style>
